import { Component, Injector, Input, OnInit } from '@angular/core';
import { CardholderDetails } from '../../data/CardholderDetails';
import { CustomerAccount } from '../../data/CustomerAccount';
import { MerchantsComponent } from './../merchants/merchants.component';
import { Card } from '../../data/Card';
import {
  UntypedFormBuilder,
  UntypedFormGroup
} from '@angular/forms';

@Component({
  selector: 'app-merchant-visaforward',
  templateUrl: './merchant-visaforward.component.html',
  styleUrl: './merchant-visaforward.component.css'
})
export class MerchantVisaforwardComponent extends MerchantsComponent {
  cardsForm: UntypedFormGroup;
  cardsAccounts: Card[];
  meus: any[] = [];
  chipOnly: boolean;
  cardSeq: number = null;
  infoSet = false;
  cardholderDetails: CardholderDetails;
  stripAccount: CustomerAccount;
  chipsAccount: CustomerAccount[];
  isEscrow: boolean;
  customerAccount: CustomerAccount;
  customerAccounts: CustomerAccount[];
  originalCardStatuses: string[] = [];
  originalChipStatuses: string[] = [];
  originalChipLimit: number[] = [];
  selectedCardDetails: any;

  constructor(
    private formBuilder: UntypedFormBuilder,
    injector: Injector
  ) {    
    super(injector);
  }

  ngOnInit() {    
    const merchant = this.merchantService.getSelectedMerchant();
    this.getMerchantAccount(merchant).subscribe(merchDetails => {
      this.customerAccounts = merchDetails.customerAccounts;
      this.stripAccount = merchDetails.customerAccounts[0];
      this.loadCardHolderDetails();
    });
  }

  loadCardHolderDetails() {
    this.cardHolderService
      .getCardholderDetails(this.stripAccount.account).subscribe(
      (data: CardholderDetails) => {
        console.log(data);
        this.cardSeq = data.cardList[0].cardSeq;
        this.cardholderDetails = data;
        this.stripAccount = data.customerAccounts[0];
        this.chipsAccount = data.customerAccounts.slice(
          1,
          data.customerAccounts.length
        );
        this.isEscrow = data.escrow;
        this.customerAccount = data.customerAccounts[0]; // Payroll Account/Strip Account
        this.customerAccounts = data.customerAccounts;
        this.cardsAccounts = data.cardList;
        console.log(this.cardsAccounts[0].cardSeq);
        (<UntypedFormGroup>this.cardsForm).patchValue(
          { cardsAccount: this.cardsAccounts[0].cardSeq }
          );
          
          this.infoSet = true;

        // Call getCardDetails()
        this.cardHolderService
          .getCardDetails(this.cardsAccounts[0].cardSeq)
          .subscribe(
            (data: String) => {
              this.selectedCardDetails = JSON.stringify(data, null, 4);
            },
            error => {
              this.messageService.error(
                'There was an error getting the card details '
              );
            }
          )

      },
      error => {
        this.messageService.error(
          'There was an error getting the card holder details ' + error.data
        );
      },
      () => {
        this.fixChipStatus();
        this.checkChipOnly();
      }
    );
    this.initForms();
  }

  initForms() {
    this.cardsForm = this.formBuilder.group({
      cardsAccount: ['', []]
    });

  }

  loadFormData() {
    console.log(this.cardsAccounts[0].cardSeq);
    this.cardsForm.patchValue(
      { cardsAccount: this.cardsAccounts[0].cardSeq }
    );
  }

  checkChipOnly() {
    const index = this.cardsAccounts.findIndex((x) => x.type !== 'CHIP');
    this.chipOnly = index < 0;
  }

  fixChipStatus() {
    for(let i : number = 0; i < this.originalCardStatuses.length; i++)
    {
      if (this.originalCardStatuses[i] == 'ACTIVE')
      {
        continue;
      }
      if (this.originalCardStatuses[i] == 'STOLEN' || this.originalCardStatuses[i] == 'LOST' || this.originalCardStatuses[i] == 'DAMAGED' || this.originalCardStatuses[i] == 'CANCELLED') {
        this.chipsAccount[i].status = 'CLOSED';
        this.originalChipStatuses[i] = 'CLOSED';
      }
    }
  }

  hasEntitlements(entitlement) {
    return this.entitlementService.hasEntitlement(entitlement);
  }

  cardChanged(newValue) {
    console.log(newValue);
  }
}
